import type { ReactNode } from 'react';

import { Label } from '@web/ui/core/atoms';

/*
 * Per DS TextField label spec: 12/16, weight 500, letter-spacing 0.5px,
 * color on-surface-variant. Stays 4 px above the field via the parent gap.
 */
export type FieldLabelProps = {
  children: ReactNode;
  required?: boolean;
  htmlFor?: string;
  endAdornment?: ReactNode;
};

export function FieldLabel({
  children,
  required,
  htmlFor,
  endAdornment,
}: Readonly<FieldLabelProps>): React.JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <Label
        htmlFor={htmlFor}
        className="text-xs font-medium leading-4 tracking-letter-space text-muted-foreground"
      >
        {children}
        {required ? <span className="ml-0.5 text-primary">*</span> : null}
      </Label>
      {endAdornment}
    </div>
  );
}
